import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";

export default function ChangePasswordForm({ testIdPrefix = "change-password" }) {
  const { logout } = useAuth();
  const [oldPwd, setOldPwd] = useState("");
  const [newPwd, setNewPwd] = useState("");
  const [confirmPwd, setConfirmPwd] = useState("");
  const [saving, setSaving] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (newPwd !== confirmPwd) {
      toast.error("New passwords do not match");
      return;
    }
    if (newPwd.length < 8) {
      toast.error("Password must be at least 8 characters");
      return;
    }
    setSaving(true);
    try {
      await api.post("/auth/change-password", {
        old_password: oldPwd,
        new_password: newPwd,
      });
      toast.success("Password updated. Please log in again.");
      setOldPwd("");
      setNewPwd("");
      setConfirmPwd("");
      setTimeout(() => {
        logout();
        window.location.href = "/login";
      }, 800);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={onSubmit} className="space-y-5 max-w-md" data-testid={`${testIdPrefix}-form`}>
      <div className="space-y-2">
        <Label htmlFor="old-pwd">Current password</Label>
        <Input
          id="old-pwd"
          type="password"
          value={oldPwd}
          onChange={(e) => setOldPwd(e.target.value)}
          required
          data-testid={`${testIdPrefix}-old-input`}
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="new-pwd">New password</Label>
        <Input
          id="new-pwd"
          type="password"
          minLength={8}
          value={newPwd}
          onChange={(e) => setNewPwd(e.target.value)}
          required
          data-testid={`${testIdPrefix}-new-input`}
        />
        <p className="text-xs text-muted-foreground">At least 8 characters.</p>
      </div>
      <div className="space-y-2">
        <Label htmlFor="confirm-pwd">Confirm new password</Label>
        <Input
          id="confirm-pwd"
          type="password"
          minLength={8}
          value={confirmPwd}
          onChange={(e) => setConfirmPwd(e.target.value)}
          required
          data-testid={`${testIdPrefix}-confirm-input`}
        />
      </div>
      <Button
        type="submit"
        disabled={saving}
        className="h-11 rounded-none font-display uppercase tracking-[0.18em]"
        data-testid={`${testIdPrefix}-submit`}
      >
        {saving ? "Updating…" : "Update password"}
      </Button>
    </form>
  );
}
